import type { DadosBancariosSubcontaModel } from "../models/dadosBancariosSubcontaModel"

export enum DadosBancariosSubcontaActionsTypes {
    CARREGAR = "CARREGAR",
    ATUALIZAR_CAMPO = "ATUALIZAR_CAMPO",
    TOKENS_CRIADOS = "TOKENS_CRIADOS",
}

type CarregarAction = {
    type: DadosBancariosSubcontaActionsTypes.CARREGAR
    payload: DadosBancariosSubcontaModel
}

type AtualizarCampoAction = {
    type: DadosBancariosSubcontaActionsTypes.ATUALIZAR_CAMPO
    payload: { campo: keyof DadosBancariosSubcontaModel; valor: unknown }
}

type TokensCriadosAction = {
    type: DadosBancariosSubcontaActionsTypes.TOKENS_CRIADOS
}

export type DadosBancariosSubcontaActions =
    | CarregarAction
    | AtualizarCampoAction
    | TokensCriadosAction
